import { ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '@/lib/auth-store'
import { useEffect } from 'react'
import { Logo } from '@/components/ui/Logo'
import { CandlestickBackground } from './CandlestickBackground'

export function Hero() {
  const { isAuthenticated, checkAuth } = useAuthStore()

  useEffect(() => {
    checkAuth()
  }, [checkAuth])

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Three.js Candlestick Background */}
      <CandlestickBackground />

      {/* Background Effects */}
      <div className="absolute inset-0 z-[1]">
        {/* Radial Gradient - Center Glow */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0.8)_0%,transparent_70%)]" />

        {/* Edge Vignette */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(0,0,0,0.9)_100%)]" />

        {/* Top Gradient */}
        <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 container px-4 mx-auto text-center">
        {/* Logo */}
        <div className="mb-10 animate-fade-in">
          <Logo size="lg" className="text-white text-2xl" />
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-8 animate-fade-in-up tracking-tight" style={{ animationDelay: '0.1s' }}>
          <span className="block bg-gradient-to-b from-white via-gray-200 to-gray-500 bg-clip-text text-transparent">
            Gestão de Banca
          </span>
          <span className="block text-white mt-2">Profissional</span>
        </h1>

        {/* Subtitle */}
        <p
          className="text-base md:text-lg text-gray-500 max-w-xl mx-auto mb-12 leading-relaxed animate-fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          Acompanhe seus resultados em tempo real com sincronização automática da sua conta Futura Broker
        </p>

        {/* CTA Button */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to={isAuthenticated ? '/dashboard' : '/login'}
            className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium text-base overflow-hidden transition-all duration-300 hover:shadow-[0_0_40px_rgba(255,255,255,0.15)]"
          >
            {/* Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-black/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />

            <span className="relative">
              {isAuthenticated ? 'Acessar Dashboard' : 'Conectar'}
            </span>
            <ArrowRight className="relative w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        {/* Stats */}
        <div
          className="flex items-center justify-center gap-8 md:gap-16 mt-16 animate-fade-in-up"
          style={{ animationDelay: '0.4s' }}
        >
          {[
            { value: 'Planilha', label: 'Exclusiva' },
            { value: '5min', label: 'Sincronização' },
            { value: '24/7', label: 'Disponível' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-xs text-gray-600 uppercase tracking-widest mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

    </section>
  )
}
